<template>
	<section class="qt-popup">
		<div class="qt-popup__ribbon">
			{{ translate("ui.new_feature_unlocked") }}
		</div>
		<div class="qt-popup__header">{{ translate("ui.quick_tool") }}</div>
		<div class="qt-popup__text">
			{{ translate("upgrade.quick_tool_description") }}
		</div>
		<AppTextButton
			class="qt-popup__button"
			:type="StatusTypes.SUCCESS"
			:text="translate('button.continue')"
			@click="close"
		/>
	</section>
</template>

<script lang="ts" setup>
import { UpgradeIds } from "@/game/entities/config/upgrades";
import useEmitter, { EmitterEvents } from "@/hooks/useEmitter";
import useUpgradesStore from "@/store/useUpgradesStore";
import { StatusTypes } from "@/types/ui";
import { translate } from "@/utils/translate";
import { markRaw } from "vue";
import AppTextButton from "../AppTextButton.vue";

const emitter = markRaw(useEmitter());

const emit = defineEmits(["close"]);

const close = (): void => {
	useUpgradesStore().increaseCurrentLevelById(UpgradeIds.quick_tool);
	emit("close");
	emitter.emit(EmitterEvents.PhaserHighlightSettlements);
};
</script>

<style lang="scss" scoped>
.qt-popup {
	@include flex-col-center;
	gap: 0.5rem;
	color: #f2dcb5;
	&__ribbon {
		color: #f4d278;
		font-weight: bold;
		font-size: 1.25rem;
		text-align: center;
		@include background(
			url($path-images + "popups/news-title-bg.avif"),
			contain,
			center,
			no-repeat
		);
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
		margin-bottom: 0.438rem;
		padding-bottom: 0.25rem;
		width: 98%;
		height: 1.875rem;
		line-height: 1.2rem;
	}
	&__header {
		font-weight: 800;
		font-size: 1rem;
		text-transform: uppercase;
	}
	&__text {
		margin-bottom: 0.5rem;
		font-size: 0.8rem;
	}
}
</style>
